import React from "react";
import { Icon } from "antd";
import I18n from "../../i18n";
import { OThemeText } from "../text/OText";
import { isFunction, isAlive } from "../../util/index";
import ImageInput from "../button/FileInputButton";
import { Metrics } from "../../theme/index";

class UploadImage extends React.Component{
    state = {
    	imageSRC: null,
    	// isLoading: false,
    }
    input = null;
    imageURI = null;
    texts={
    	guidelineMessages:[],
    	uploadMessage:"",
    	removeMessage:"",
    	removeTitle:"",
    	removeConfirmMessage:"",
    }

    constructor(props){
    	super(props);
    	this.texts = {
    		guidelineMessages: I18n.t("logo_upload.guideline_message").split("\n"),
    		uploadMessage:I18n.t("logo_upload.upload_message"),
    		removeMessage:I18n.t("logo_upload.remove_message"),
    		removeTitle:I18n.t("logo_upload.remove_logo.title"),
    		removeConfirmMessage:I18n.t("logo_upload.remove_logo.message"),
    	};
    	const { src=null, setRef } = props;
    	this.state = {
    		imageSRC:src,
    		// isLoading:isAlive(src)
    	};
    	if(isFunction(setRef)){
    		setRef(this);
    	}
    }
    componentWillReceiveProps(props){
    	this.setState({
    		imageSRC: props.src,
    		// isLoading: isAlive(props.src)
    	});
    }
    onFileChange(event) {
    	const { onInvalidType, onFileLoaded } = this.props;
    	if(event.target.files.length === 1){
    		const file = event.target.files[0];
    		//console.log('on receive file: ', file, ' as type: ', file.type);
    		if (this.props.acceptTypes.indexOf(file.type) === -1) {
    			if(isFunction(onInvalidType)){
    				onInvalidType();
    			}
    		} else {
    			this.imageURI = file;
    			let reader = new FileReader();
    			reader.onloadend = (e) => {
    				// this.imageBase64 = e.target.result;
    				this.setState({ imageSRC: e.target.result });
    				if(isFunction(onFileLoaded)){
    					onFileLoaded(e.target.result);
    				}
    			};
    			reader.readAsDataURL(file);
    		}
    	}
    }
    onImageLoaded(){
    	this.setState({isLoading:false});
    }
    setImageSRC(src = null){
    	this.setState({
    		imageSRC:src,
    		// isLoading:isAlive(src)
    	});
    }
    getImageSRC(){
    	return this.state.imageSRC;
    }
    getImageURI(){
    	return this.imageURI;
    }
    clearImage(){
    	this.imageURI = null;
    	this.setState({imageSRC:null});
    }
    render(){
    	const { acceptTypes, size, imageSize } = this.props;
    	const hasImage = isAlive(this.state.imageSRC);
    	let containerStyle = {
    		width:size, height:size,
    		marginBottom: Metrics.button.spaceMargin,
    		display:"flex",
    		justifyContent:"center",
    		borderRadius:size/2, 
    		border: "solid 12px #f4f4f4",
    		backgroundColor:"#c8c8c8",
    		alignItems:"flex-end",
    	};
    	return (
    		<div style={{display:"inline-block"}}>
    			{/* <ContainerLoading isLoading={this.state.isLoading}> */}
    			<div style={containerStyle}>
    				{hasImage ? 
    					<img style={{
    						alignSelf:"center", 
    						position:"absolute",
    						objectFit:"contain", 
    						maxWidth:imageSize,
    						maxHeight:imageSize
    					}} 
    					alt=""
    					src={this.state.imageSRC} 
    					onLoad={this.onImageLoaded.bind(this)}
    					/>
    					: <Icon 
    						style={{
    							alignSelf:"center", 
    							position:"absolute",
    							fontSize:83,
    							color:"#FFF"
    						}} 
    						type="question-circle-o" 
    					/>}
    				<ImageInput 
    					accept={acceptTypes}
    					style={{paddingBottom:15}}
    					buttonProps={{height:Metrics.button.wrapperHeight}} 
    					onFileChange={this.onFileChange.bind(this)}>
    					{this.texts.uploadMessage}
    				</ImageInput>
    			</div>
    			<div style={{textAlign:"center"}}>
    				<span style={{display:"inline-flex"}}>
    					<OThemeText style={{maginBottom:0}}>{this.texts.guidelineMessages[0]}</OThemeText>
    					<p style={{marginLeft:4}}>{this.texts.guidelineMessages[1]}</p>
    				</span>
    				{this.texts.guidelineMessages.slice(2).map((v,i)=>(
    					<p key={i}>{v}</p>
    				))}
    			</div>
    			{/* </ContainerLoading> */}
    		</div>
    	);
    }
}
UploadImage.defaultProps = {
	src:null,
	acceptTypes:["image/png"], //,'image/jpg','image/jpeg'],
	onInvalidType:()=>{console.log("receive invalid file type");},
	onFileLoaded:null,//(file)=>{console.log('file loaded: ',file);},
	size: 300,
	imageSize: 150,
	isLoading: false,
};
export default UploadImage;


// WEBPACK FOOTER //
// ./src/components/layout/UploadImage.js